// LoginPage.js
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import AlertModal from './AlertModal';
const Sakura = () => {

  return (
    <div className="sakura-container">
      {[...Array(30)].map((_, i) => (
        <div
          key={i}
          className="sakura"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            animationDuration: `${5 + Math.random() * 5}s`,
          }}
        />
      ))}
    </div>
  );
};

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [closeCallback, setCloseCallback] = useState(null);
  // Redirect to main page if already authenticated.
  useEffect(() => {
    if (localStorage.getItem('isAuth') === 'true') {
      navigate('/main');
    }
    else if (localStorage.getItem('isPublic') === 'true') {
      navigate('/public-main');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call (replace with real auth logic)
    await new Promise(resolve => setTimeout(resolve, 1000));
    console.log('Login payload:', { username, password });
    setIsLoading(false);
    if (username === "Saboten758" && password === "ttcmp1234"){
      localStorage.setItem('isAuth', 'true');
      navigate('/main');
    }
    else{
      showAlert("Bhai abar try kor! :<");
    }
  };
  const showAlert = (message, onCloseCallback) => {
    setModalMessage(message);
    setIsModalOpen(true);
    setCloseCallback(() => onCloseCallback);
  };
  const handleTryIt = (e) => {
    e.preventDefault();
    showAlert("This will use the browser's local storage to store your notes (markdown files). These Notes are private to you and may be deleted automatically once you clear the browser's cache", () => {
      localStorage.setItem('isPublic', 'true');
      navigate('/public-main');
    });
  };
  
  const handleRequestAccess = (e) => {
    e.preventDefault();
    showAlert("ok...but why? :< \n You can just try it out :p");
    const email = "arakuro98@gmail.com"; // Replace with the actual email address
    const subject = "Gimme Access";
    const body = "Hello,\n\nI would like to look at your notes on shinkiro so gimme access!\n\nMeow meow meow :p!";
    window.open(`mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalMessage('');
    if (closeCallback) {
      closeCallback();
      setCloseCallback(null);
    }
  };

  return (
    <div className="login-container">
      <Sakura />
      {isModalOpen && (
        <AlertModal message={modalMessage} onClose={handleCloseModal} />
      )}
      <div className="content-wrapper">
        <div className="login-card">
          <div className="logo-section">
            <h1 className="title">Shinkirō</h1>
            <p className='subtitle'>蜃気楼</p>
            <p className="subtitle">Markdown Sanctuary</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                required
              />
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            <div className="button-group">
              <button 
                type="submit" 
                className={`primary-button ${isLoading ? 'loading' : ''}`}
                disabled={isLoading}
              >
                {isLoading ? 'Unlocking...' : 'Unlock Sanctuary'}
              </button>
              
              <button 
                type="button" 
                className="secondary-button"
                onClick={handleRequestAccess}
              >
                Request Access
              </button>

              <button 
                type="button" 
                className="secondary-button"
                onClick={handleTryIt}
              >
                Try It
              </button>
            </div>
          </form>

          <div className="footer-links">
            <a href="#forgot-password">Forgot Password?</a>
            <span className="separator">•</span>
            <a href="#help">Need Help?</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
